// extracted by mini-css-extract-plugin
export default {"fixBottom":"index_fixBottom_16yvC","whiteBg":"index_whiteBg_S0duK","content_list":"index_content_list_SCKGq","chip_item":"index_chip_item_X1o10"};